export const VALIDATION_MAPPING: Record<string, string> = {
    // ─── ORDERS ───
    client_id: "Client Id is required",
    reference_no: "Reference Number is required",
    receiver_name: "Full name is required",
    receiver_mobile: "Receiver Phone (10–12 digits) is required",
    receiver_email: "Receiver Email is Optional",
    receiver_country: "Receiver Country.",
    receiver_city: "Receiver City is required",
    receiver_district: "Receiver District / Area",
    receiver_address: "Receiver Address is required",
    receiver_national_address: "Receiver National Address is required",
    shipment_cost: "Shipment Cost is Optional",
    payment_type: "Payment Type (CC, COD)",
    cod_amount: "Cod Amount is required",
    no_of_pieces: "Number of Pieces is required",
    weight: "Weight is required",
    service: "Service is required",
    shipment_type: "Shipment Type (PARCEL)",
    description: "Description is Optional",
    latitude: "Latitute is Optional",
    longitude: "Longitude is Optional",
    product_id_1: "Product ID 1 is required",
    quantity_1: "Quantity 1 is required",
    product_id_2: "Product ID 2 is optional",
    quantity_2: "Quantity 2 is optional",
    product_id_3: "Product ID 3 is optional",
    quantity_3: "Quantity 3 is optional",
    product_id_4: "Product ID 4 is optional",
    quantity_4: "Quantity 4 is optional",
    product_id_5: "Product ID 5 is optional",
    quantity_5: "Quantity 5 is optional",

    // ─── CLIENT / OUTSOURCE / STAFF / DRIVERS ───
    company_name: "Company Name is required",
    full_name: "Full name is required",
    name: "Full name is required",
    phone: "Phone (10–12 digits) is required",
    mobile: "Phone (10–12 digits) is required",
    mobile_no: "Phone (10–12 digits) is required",
    email: "Valid email is required",
    contact_person: "Contact Person Name required",
    contact_method: "Contact Method (Phone, Email & Whatsapp)",
    warehouse: "Warehouse is required",
    payment_term: "Payment Term (Daily, Weekly & Monthly)",
    access_type: "Access Type (LM, FM & Both)",
    client_type: "Merchant Type is required",
    short_address: "Short Address is required",
    location: "Full Address is required",
    full_address: "Full Address is required",
    vat_number: "Vat Number (15 digits) is required",
    cr_number: "CR Number (10 digits) is required",
    national_id: "National Id (10 digits) is required",
    contract_date: "Contract Date (YYYY-MM-DD) is required",
    supervisor_name: "Supervisor Name (Optional)",
    start_date: "Start Date (YYYY-MM-DD) is required",
    iqama_number: "Iqama Number (10 digits) is required",
    iqama_no: "Iqama Number (10 digits) is required",
    vehicle_type: "Vehicle Type (Car, Van & DoKker)",
    vehicle_name: "Vehicle Name (Optional)",
    license_number: "License Number",
    service_area: "Service Area is required",
    role: "Role is required",
    address: "Address required.",
    specialization: "Specialization is required",
    billing_cycle: "Billing Cycle Term (Daily, Weekly & Monthly)",
    contract_start_date: "Start Date (YYYY-MM-DD) is required",
    contract_end_date: "End Date (YYYY-MM-DD) is optional", 
    primary_contact_name: "Primary Contact Name is required", 
    primary_contact_email: "Primary Contact Number is required", 
    primary_contact_number: "Primary Contact Email is required", 
    contact_types:    "Contact Method (Phone, Email & Whatsapp)",
    access:      "Access Type (LM, FM & Both)",
    roles: "Role is required",

    // ─── ITEMS ───
    itemName: "Item Name is required",
    sku: "SKU is required",
    category: "Category is required",
    subCategory: "Sub Category is required",
    storage_type: "Storage Type (PALLETS / BINS) is required",
    capacity: "Capacity is required",
    minimum_quantity: "Minimum Quantity is required",
    length: "Length is optional",
    width: "Width is optional",
    height: "Height is optional",
    expiry: "Expiry (YES / NO) is required",
    commodity: "Commodity is optional",
    import_commodity: "Import Commodity is optional",
    dangerous_goods: "Dangerous Goods (YES / NO) is required",
    hs_code: "HS Code is optional",
    price1: "Price 1 is optional",
    price2: "Price 2 is optional",
    minimum_order: "Minimum Order is optional",
    short_description: "Short Description is optional",
    long_description: "Long Description is optional",

    // ─── VEHICLES ───
    company: "Company is required",
    model: "Model is required",
    year: "Year is required",
    fuel_type: "Fuel Type is optional",
    vehicle_number: "Vehicle Plate Number is required",
    registration_type: "Registration Type is optional",
    color: "Color is optional",
    sequence_number: "Sequence Number is required",
    odometer: "Odometer is optional",
    rc_number: "Vehicle ID is required",
    inspection_expiry_date: "Inspection Expiry Date is optional",
    registration_expiry_date: "Registration Expiry Date is optional",
    insurance_company: "Insurance Company is optional",
    insurance_start_date: "Insurance Start Date is optional",
    insurance_end_date: "Insurance End Date is optional",

    // ─── ALWAYS LAST ───
    reason: "Reason (System generated, not required)",
};